export default __webpack_public_path__ + "static/media/thumb-light.791adc3f.svg";